// Core
import { usePathname, useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

// Definitions
import { PaginationType } from "@/types/basic";
import { FilterStaticQueryParamsType } from "@/types/filter";

// Utils
import st from "./index.module.scss";

type PaginationProps = {
  pagination: PaginationType | null;
  searchParams?: FilterStaticQueryParamsType;
};
export default function Pagination({ pagination = null, searchParams }: PaginationProps) {
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations("Pagination");

  const handlePaginate = useCallback(() => {
    if (searchParams !== undefined) {
      const queryParams = new URLSearchParams(searchParams as Record<string, string>);
      if (pagination?.next) {
        queryParams.set("page", String(pagination?.next));
      }
      router.push(pathname + "?" + queryParams.toString(), { scroll: false });
    }
  }, [searchParams, pagination]);

  if (!pagination || !pagination?.next) {
    return null;
  }

  const { next, count, current, last, perPage } = pagination;
  const progressPercent = (current / last) * 100;

  return (
    <div className={st.wrapper}>
      <label className={st.label}>
        {t("label", {
          count: !next ? count : current * perPage,
          total: count,
        })}
      </label>
      <progress className={st.progress} max={100} value={progressPercent}>
        {progressPercent}%
      </progress>
      <button className={st.action} onClick={handlePaginate}>
        {t("loadMore")}
      </button>
    </div>
  );
}
